'use client';

import { DnsZonesSettingsSection } from '@terra/ui-design-system';
import { usePermissions } from '../../../../hooks/usePermissions';
import {
  useAttachExternalNetworkDnsZone,
  useDetachExternalNetworkDnsZone,
  useExternalNetworkDnsZoneAttachments,
  useSyncExternalNetworkDnsZones,
  useUpdateExternalNetworkDnsZonePolicy,
  useVerifyExternalNetworkDnsZoneDelegation,
} from '../../../../hooks/api/useExternalNetworkDnsZones';
import { useOpenWebAppPage } from '../../../../hooks/useOpenWebAppPage';
import { WEB_APP_PATHS } from '../../../../utils/webAppPaths';

export function ExternalDnsZonesSettingsPanel({
  surfaceId,
}: {
  surfaceId: string;
}) {
  const { canManageApplications } = usePermissions();
  const openWebAppPage = useOpenWebAppPage();
  const { attachments, isLoading, isError } =
    useExternalNetworkDnsZoneAttachments({ surfaceId });
  const attach = useAttachExternalNetworkDnsZone();
  const detach = useDetachExternalNetworkDnsZone();
  const sync = useSyncExternalNetworkDnsZones();
  const updatePolicy = useUpdateExternalNetworkDnsZonePolicy();
  const verify = useVerifyExternalNetworkDnsZoneDelegation();

  return (
    <DnsZonesSettingsSection
      attachments={attachments}
      isLoading={isLoading}
      isError={isError}
      isReadOnly={!canManageApplications}
      pending={{
        isAttaching: attach.isPending,
        isDetaching: detach.isPending,
        isSyncing: sync.isPending,
        isUpdatingPolicy: updatePolicy.isPending,
        isVerifying: verify.isPending,
      }}
      onAttach={(body) => attach.mutateAsync({ surfaceId, body })}
      onDetach={(body) => detach.mutateAsync({ surfaceId, body })}
      onSync={(body) => sync.mutateAsync({ surfaceId, body })}
      onVerify={({ zoneId }) => verify.mutateAsync({ surfaceId, zoneId })}
      onUpdatePolicy={({ zoneId, body }) =>
        updatePolicy.mutateAsync({ surfaceId, zoneId, body })
      }
      onOpenIntegrations={() => openWebAppPage(WEB_APP_PATHS.integrations)}
    />
  );
}
